import React, { useState } from "react"
import {
  Button,
  Modal,
  Space,
  Typography,
  Row,
  Col,
  message,
  Input,
  Divider,
  Skeleton,
  InputNumber,
} from "antd"
import { ArrowRightOutlined } from "@ant-design/icons"
import { arrayUnion, doc, updateDoc } from "firebase/firestore"
import { db } from "../../../../firebase/config"
import { useAuthContext } from "../../../../hooks/useAuthContext"

const { Text, Link } = Typography
const { TextArea } = Input

export default function PmChangeFormat({ data }) {
  const { user } = useAuthContext()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedFormat, setSelectedFormat] = useState(null)
  const [commentOnSwap, setCommentOnSwap] = useState(null)
  const [modalLoading, setModalLoading] = useState(false)

  const showModal = () => setIsModalOpen(true)

  const handleOk = async (e) => {
    e.preventDefault()
    setModalLoading(true)
    const ref = doc(db, "orders", data.id)

    const correctionTimestamp = new Date() // Client-side timestamp

    // Define the correction object
    const correction = {
      correctedAttribute: "format",
      correctionComment: commentOnSwap,
      newValues: {
        formatWidth: selectedFormat,
      },
      oldValues: {
        formatWidth: data.selectedProduct.formatWidth,
      },
      correctedBy: user.uid,
      correctionByEmail: user.email,
      correctionDate: correctionTimestamp,
      seen: false,
    }

    try {
      await updateDoc(ref, {
        "selectedProduct.formatWidth": selectedFormat,
        orderCorrected: true,
        correctionHistory: arrayUnion(correction),
      }).then(() => {
        message.success("format changed!")
      })
    } catch (err) {
      message.error("error happened")
      console.log(err)
    } finally {
      setModalLoading(false)
      setCommentOnSwap(null)
      setSelectedFormat(null)
      setIsModalOpen(false)
    }
  }

  const handleCancel = () => {
    setModalLoading(false)
    setCommentOnSwap(null)
    setSelectedFormat(null)
    setIsModalOpen(false)
  }

  const handleFormatChange = (value) => {
    setSelectedFormat(value)
  }

  return (
    <>
      <Button block style={{ background: "#fa541c" }} type="primary" onClick={showModal}>
        Change Format
      </Button>
      <Modal
        title={"Change Format"}
        open={isModalOpen}
        okButtonProps={{
          loading: modalLoading,
          disabled: selectedFormat === null ? true : false || commentOnSwap === null ? true : false,
        }}
        onCancel={handleCancel}
        onOk={handleOk}
        cancelButtonProps={{ loading: modalLoading }}>
        <Skeleton loading={modalLoading}>
          <Row>
            <Col span={24}>
              <Space>
                <Text>Current Format Width:</Text>
                <Link>{data.selectedProduct.formatWidth}mm</Link>
                <ArrowRightOutlined />
                <InputNumber
                  style={{ width: 200 }}
                  size="small"
                  placeholder="new format width"
                  value={selectedFormat}
                  onChange={handleFormatChange}
                />
              </Space>
            </Col>
            <Divider>Comment</Divider>
            <Col span={24}>
              <TextArea
                rows={4}
                placeholder="comment on change"
                value={commentOnSwap}
                onChange={(event) => setCommentOnSwap(event.target.value)}
              />
            </Col>
          </Row>
        </Skeleton>
      </Modal>
    </>
  )
}
